import { render, staticRenderFns } from "./StudyCoordinators.vue?vue&type=template&id=49d471fc&"
import script from "./StudyCoordinators.vue?vue&type=script&lang=js&"
export * from "./StudyCoordinators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports